
import React from 'react'
import { useState, useEffect } from 'react'
import { GlobalOutlined } from '@ant-design/icons';
import { message, Pagination, Spin } from 'antd';
import { Table } from 'antd';
import { useNavigate } from 'react-router-dom' //路由跳转使用 useNavigate react-router v6已经把usehistory替换成了useNavigate
import SortOrFilter from '@/components/TableBuilder/SortOrFilter';
import { GetRoutesList } from '@/services/pipeline_gad_map.js'
import { changeDataType } from "@/common/js/common.js" //引入公共方法
import local from '@/utils/local'

function Pipelinediagram (props) {
  const navigate = useNavigate();
  const token = local.get('cruise_m350_token');

  const [current, setCurrent] = useState(1);//第几页
  const [data, setData] = useState([]);//表格数据
  const [total, setTotal] = useState(0);//总共多少条
  const [loading, setLoading] = useState(false);

  const [param, setParam] = useState({
    access_token: token,
    page: current,
    perpage: 10,
  })


  const columns = [ //表格头
    {
      title: '管线名称',
      dataIndex: 'title',
      render: (text, record) => (
        <span style={{ color: '#1890FF', cursor: 'pointer' }}
          onClick={
            () => {
              navigate('/pipeline_gad_map_info', { state: { id: record.id, name: text } })
            }
          }
        >
          {text}
        </span>

      )
    },
    {
      title: '总里程(km)',
      dataIndex: 'length',
      width: '160px',
    },
    {
      title: '更新时间',
      dataIndex: 'time',
      width: '200px',
      render: (text, record) => (
        record.time
          ? (
            <div>
              <span className='fSize14 opacity0_85 margR8'>{record.showDate}</span>
              <span className='fSize14 opacity0_45'>{record.showTime}</span>
            </div>
          )
          : (
            <span className='fSize14 opacity0_45'>-</span>
          )
      )
    },
  ];


  //获取表格数据
  const getData = async (page) => {
    setLoading(true);
    let obj = {
      access_token: token,
      page: page.page,
      perpage: page.perpage,
    }
    let res = await GetRoutesList(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了!');
      return;
    }
    //console.log('获取表格数据');
    //console.log(res);
    for (let i = 0; i < res.data.items.length; i++) {
      let val = res.data.items[i];
      if (val.time) {
        let date = changeDataType(val.time);
        val.showDate = date.date;
        val.showTime = date.time;
      } else {
        val.showDate = '';
        val.showTime = '';
      }
    }
    setTotal(res.data.total);
    setData([...res.data.items]);
    setLoading(false);
  };

  //在函数组件中，组件加载完成后执行
  useEffect(() => {
    getData(param);
  }, [])// eslint-disable-line

  return (
    <div className="hei100 padd_24 borbox tablebackcol" style={{ overflowY: 'auto' }}>
      <div className="flex-col paddRL24 paddT24 backcol">
        <div className="borbox">
          <Spin spinning={loading}>
            <Table
              columns={columns}
              // rowSelection={rowSelection}
              dataSource={data}
              pagination={false}
              rowKey="id"
              onChange={(pagination, filters, sorter) => {
                setCurrent(1);
                let val = SortOrFilter(pagination, filters, sorter);
                let obj = { ...param };
                obj.order = val.sorter;
                obj.page = 1;
                setParam({ ...obj });
                getData(obj);
              }}
            />
          </Spin>
        </div>
        <div className="min-h64 tt_a_r disFlex aliItemsCen">
          <Pagination
            total={total}
            showSizeChanger
            showQuickJumper
            showTotal={total => `共 ${total} 条数据`}
            style={{ marginLeft: 'auto' }}
            current={current}
            onChange={
              (current, pageSize) => { //选择当前页后执行
                let obj = { ...param };
                obj.page = current;
                setCurrent(current);
                obj.perpage = pageSize;
                // obj.order='';
                setParam({ ...obj });
                //console.log(param);
                getData(obj);
              }
            }
          />
        </div>
      </div>
    </div>
  );
}
export default Pipelinediagram